import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { compose } from 'ramda';
import { withTranslation } from 'react-i18next';
import { parsePdf } from 'store/actionCreators/newCardioReport';
import { FORM_NAMES } from 'constants/forms';
import { uploadTachyReport } from 'store/actionCreators/newTachyReport';
import Upload from 'components/TachyReport/Upload';
import validate from './validate';

const mapDispatchToProps = {
  parsePdf,
  onSubmit: uploadTachyReport,
};

export default compose(
  withTranslation(),
  connect(
    null,
    mapDispatchToProps,
  ),
  reduxForm({
    form: FORM_NAMES.uploadTachyReport,
    validate,
  }),
)(Upload);
